// extracted by mini-css-extract-plugin
export default {"badge":"RouteStatusBadge_badge__tDv6C","active":"RouteStatusBadge_active__H2PNX","completed":"RouteStatusBadge_completed__svpMd","planned":"RouteStatusBadge_planned__g1Dxf"};